<template>
  <section class="news-title-layout">
    <div class="news-title">{{ title }}</div>
    <div class="news-title-desc">{{ desc }}</div>
  </section>
</template>

<script>
export default {
  props: ["title", "desc"]
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixin.scss";
.news-title-layout {
  display: flex;
  align-items: flex-end;
  @include small-mobile {
    flex-direction: column;
    align-items: normal;
  }
  @include mobile {
    flex-direction: column;
    align-items: normal;
  }
  .news-title {
    font-size: 1.2em;
    font-weight: bold;
    margin-right: 5px;
  }
  .news-title-desc {
    font-size: 12px;
    color: darkgrey;
  }
}
</style>
